import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiLayers, FiHash, FiTag } = FiIcons;

export default function Sidebar({ 
  onAddClick, 
  categories, 
  tags,
  selectedCategory, 
  onSelectCategory,
  selectedTag,
  onSelectTag
}) {
  return (
    <aside className="w-60 bg-slate-900 border-r border-slate-800 h-screen flex flex-col flex-shrink-0">
      <div className="p-5 border-b border-slate-800">
        <div className="flex items-center gap-3 text-white font-bold text-lg tracking-tight">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/184c9c9a291724797b8ad828c55b10701c0f1ac03d6d548cee29a666ff97a2e9df5b13aa801d7dcc8d672f63188942d5/images/aW1hZ2UvcG5n/23a0726a4b7957f773bb9be8533262a8.png" 
            alt="Snippet Vault Logo" 
            className="w-8 h-8 rounded-lg"
          />
          Snippet Vault
        </div>
      </div>

      <div className="p-4 flex-1 overflow-y-auto custom-scrollbar">
        <button
          onClick={onAddClick}
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white flex items-center justify-center gap-2 py-2 px-4 rounded-lg font-medium transition-colors mb-6 shadow-sm"
        >
          <SafeIcon icon={FiPlus} />
          New Snippet
        </button>

        <div className="space-y-6">
          <div>
            <h3 className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3 px-2">
              Languages
            </h3>
            <ul className="space-y-0.5">
              <li>
                <button
                  onClick={() => { onSelectCategory('all'); onSelectTag(null); }}
                  className={`w-full flex items-center gap-2.5 px-3 py-1.5 rounded-md text-sm transition-colors ${
                    selectedCategory === 'all' && !selectedTag ? 'bg-slate-800 text-indigo-400' : 'text-slate-400 hover:bg-slate-800/50 hover:text-slate-200'
                  }`}
                >
                  <SafeIcon icon={FiLayers} className="w-4 h-4" />
                  All Snippets
                </button>
              </li>
              {categories.map(lang => (
                <li key={lang}>
                  <button
                    onClick={() => { onSelectCategory(lang); onSelectTag(null); }}
                    className={`w-full flex items-center gap-2.5 px-3 py-1.5 rounded-md text-sm transition-colors capitalize ${
                      selectedCategory === lang ? 'bg-slate-800 text-indigo-400' : 'text-slate-400 hover:bg-slate-800/50 hover:text-slate-200'
                    }`}
                  >
                    <SafeIcon icon={FiHash} className="w-4 h-4" />
                    {lang}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {tags.length > 0 && (
            <div>
              <h3 className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3 px-2">
                Tags
              </h3>
              <div className="flex flex-wrap gap-1.5 px-1">
                {tags.map(tag => (
                  <button
                    key={tag}
                    onClick={() => { onSelectTag(tag); onSelectCategory('all'); }}
                    className={`flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-medium border transition-all ${
                      selectedTag === tag 
                        ? 'bg-indigo-500/10 text-indigo-400 border-indigo-500/50' 
                        : 'bg-slate-800/50 text-slate-400 border-slate-700/50 hover:border-slate-600 hover:text-slate-300'
                    }`}
                  >
                    <SafeIcon icon={FiTag} className="w-2.5 h-2.5" />
                    {tag}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="p-4 border-t border-slate-800 text-center">
        <p className="text-[10px] text-slate-600 font-medium tracking-tight">
          &copy; {new Date().getFullYear()} Snippet Vault
        </p>
      </div>
    </aside>
  );
}